module.exports = __webpack_public_path__ + "img/nameplate_icon.1923d286.png";